import { SearchInput } from '../shared';
import { SortOrder, DistrictSortType } from '../enums';

export class GetDistrictsInput extends SearchInput<DistrictSortType> {
    public provinceId?: number | null;

    constructor() {
        super(DistrictSortType.Name);
        this.provinceId = null;
        this.sortOrder = SortOrder.Ascending;
    }
}
